<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  words: {
    type: Array,
    required: true
  }
});

// General framework stuff
const { t } = useI18n();

// Template properties
const wordsFormatted = computed(() => props.words.slice(0, 2).join(", "));
const countOthers = computed(() => Math.max(0, props.words.length - 2));
</script>

<template>
  <div class="word-list-examples">
    <span>{{ t("vocab.wordList.exampleWords.words", { count: words.length }) }}&nbsp;</span>
    <span>{{
      t(
        "vocab.wordList.exampleWords.examples",
        {
          examples: wordsFormatted,
          countOthers
        },
        countOthers
      )
    }}</span>
  </div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.word-list-examples {
  color: rgb(@theme-colors[@grey][base]);
  font-size: 0.75rem;
  line-height: 1rem;
  word-break: break-word;
}
</style>
